import {useToast} from '@chakra-ui/react';
import type {Player} from '../types';
import {useTranslate} from '@eksab/i18n';
import {useLineupStore} from './useLineupStore';
import {useCompetitionQuery} from '../hooks';

export const useAddPlayer = (competitionId: string) => {
  const t = useTranslate();
  const toast = useToast();
  const addPlayer = useLineupStore((state) => state.addPlayer);
  const players = useLineupStore((state) => state.players);
  const substitues = useLineupStore((state) => state.substitutes);

  const competitionQuery = useCompetitionQuery(competitionId);

  const add = (player: Player) => {
    const playerTeammates = [...players, ...substitues]
      .flat()
      .filter((existingPlayer) => existingPlayer && existingPlayer.team.id === player.team.id);

    if (
      competitionQuery?.data?.fantasy_limit?.player_limit &&
      playerTeammates.length === competitionQuery?.data?.fantasy_limit?.player_limit
    ) {
      return toast({
        status: 'error',
        title: t('fantasy.lineup.over-players-limit.error', {
          limit: competitionQuery?.data?.fantasy_limit?.player_limit,
        }),
      });
    }
    addPlayer(player);
  };

  return add;
};
